define('presentation/settings/reports/viewModels/reportsViewModel',[
    'businessServices/router/router',
    'common/promises/promiseFactory',
    'common/collections/collectionFilter',
    'common/collections/collectionSorter',
    'common/storage/commonState',
    'presentation/common/actionModal/viewModels/actionModalViewModel',
    'presentation/common/actionModal/viewModels/deleteReportActionViewModel',
    'presentation/settings/reports/facades/reportsFacade'
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const DeleteReportActionViewModelConstructor = require('presentation/common/actionModal/viewModels/deleteReportActionViewModel');
        const FilterConstructor = require('common/collections/collectionFilter');
        const SorterConstructor = require('common/collections/collectionSorter');

        const _commonState = require('common/storage/commonState');
        const _router = require('businessServices/router/router');

        let _facade = null;

        const DELETE_RESPONSE = "yes";

        const _buildDeleteConfirmationModelContent = (report) => {
            const displayType = _commonState.typeDisplay.report;
            let constructorParams = [report];
            self.actionModal
                .clearModal()
                .setContentViewModel(DeleteReportActionViewModelConstructor, constructorParams)
                .setHeaderText({i18n: {key: 'deleteHeader', options: {type: displayType}}})
                .setSubmitButtonText({i18n: 'delete'});
        };

        const _getScheduledReports = () => {
            _facade.getScheduledReports()
                .done((reports) => {
                    self.availableReports(reports);
                });
        };

        self.actionModal = null;
        self.isCompositionComplete = ko.observable(false);
        self.availableReports = ko.observableArray([]);

        self.filteredReports = ko.pureComputed(() => {
            const filterContent = self.searchFilter();
            const availableReports = self.availableReports();

            if (filterContent === '') {
                return availableReports;
            }

            const reportFilter = new FilterConstructor();
            reportFilter.addProperty('subject');
            reportFilter.addProperty('deliveryFrequencyText');
            reportFilter.addValue(filterContent);
            return reportFilter.filter(availableReports);
        });

        self.displayReports = ko.pureComputed(() => {
            const sortableReports = self.filteredReports();
            const sorter = new SorterConstructor();
            if (sorter.setOptions(self.sortOptions(), self.sortType())) {
                sorter.sort(sortableReports);
            }
            return sortableReports;
        });

        self.sortOptions = ko.observableArray([
            {textI18n: "reportSubject", iconName: 'sortName', sortPath : "subject", isAscending : true},
            {textI18n: "reportFrequency", iconName: 'sortFrequency', sortPath : "deliveryFrequencyText", isAscending : true},
            {textI18n: "recentlyAdded", iconName: 'sortRecentlyAdded', sortPath : "createdDateTime.sortValue", isAscending : false},
            {textI18n: "recentlyModified", iconName: 'sortRecentlyModified', sortPath : "modifiedDateTime.sortValue", isAscending : false}
        ]);
        self.sortType = ko.observable("name");
        self.searchFilter = ko.observable('');

        self.showResults = ko.pureComputed(() => self.displayReports().length > 0);
        self.emptyStateContentKey = ko.pureComputed(() => self.availableReports().length > 0 ? "noResults" : "noReports");

        self.deleteScheduledReport = (report) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _buildDeleteConfirmationModelContent(report);
                self.actionModal.showModal()
                    .done((response) => {
                        if (response === DELETE_RESPONSE) {
                            const reportId = report.scheduledReportId;
                            _facade.deleteScheduledReport(reportId)
                                .done(() => {
                                    self.availableReports.remove(report);
                                })
                                .fail((error) => {
                                    error.scheduledReportId = reportId;
                                    throw error;
                                });
                        } else {
                            deferredObject.resolve();
                        }
                    })
                    .fail((error) => {
                        error.scheduledReport = report;
                        deferredObject.reject(error);
                    });
            });
        };

        self.navigateToEditReport = (report) => {
            _router.navigate(report.editScheduledReportUrl);
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/settings/reports/facades/reportsFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const ActionModalViewModelConstructor = require('presentation/common/actionModal/viewModels/actionModalViewModel');
            self.actionModal = new ActionModalViewModelConstructor();

            return _initialize();
        };

        const _initialize = () => {
            _getScheduledReports();

            return _promiseFactory.wait();
        };
    };
});

